import React, { useEffect } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import ActivationEmailForm from "../../components/Auth/ActivationEmailForm";
import AuthBackgroundSlideshow from "../../components/AuthBackground/Slideshow";

const ActivationEmail = () => {
  const [searchParams] = useSearchParams();
  const emailParam = searchParams.get("email");

  // If no email parameter in URL, redirect to login
  if (!emailParam) {
    return <Navigate to="/auth/sign-in/" replace />;
  }

  return (
    <>
      {/* Animated Background Slideshow */}
      <AuthBackgroundSlideshow />
      <ActivationEmailForm emailFromUrl={emailParam} />
    </>
  );
};

export default ActivationEmail;
